import { prop } from '@ipfabric/utils/fp/prop';
import { useGlobalStateContextSelectors } from 'components/GlobalState/GlobalStateModel';
import type { PermissionScope } from 'utils/hooks/usePermissionScope';

type HasPermissionHook = (
  requiredScopes: PermissionScope | PermissionScope[],
) => boolean;

export const useHasPermission = (): HasPermissionHook => {
  const ctxProps = useGlobalStateContextSelectors({
    scope: prop('auth', 'scope'),
  });

  return (requiredScopes: PermissionScope | PermissionScope[]): boolean => {
    const requiredScopesToCompare =
      typeof requiredScopes === 'string' ? [requiredScopes] : requiredScopes;

    return requiredScopesToCompare.every(
      (permission) => ctxProps.scope.indexOf(permission) !== -1,
    );
  };
};
